import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

export default {
    path: '/warehouses',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
    component: () => import('../components/pages/warehouse/WarehouseGeneral.vue'),
    children: [
        { path: '', redirect: '/warehouses/stocks' },
        {
            path: 'warehouses', name: "WarehousesWarehouses",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
            component: () => import('../components/pages/warehouse/Warehouses.vue')
        },
        {
            path: 'groups', name: "WarehousesGroups",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
            component: () => import('../components/pages/warehouse/Groups.vue')
        },
        {
            path: 'kits', name: "WarehousesKits",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
            component: () => import('../components/pages/warehouse/Kits.vue')
        },
        {
            path: 'suppliers', name: "WarehousesSuppliers",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
            component: () => import('../components/pages/warehouse/Suppliers.vue')
        },
        {
            path: 'stocks', name: "WarehousesStocks",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
            component: () => import('../components/pages/warehouse/Stocks.vue')
        },
        {
            path: 'stocks_archive', name: "WarehousesStocksArchive",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
            component: () => import('../components/pages/warehouse/StocksArchive.vue')
        },
        {
            path: 'documents', name: "WarehousesDocuments",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
            component: () => import('../components/pages/warehouse/Documents.vue')
        },
        {
            path: 'marking', name: "WarehousesMarking",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials', 'chestny_znak'] },
            component: () => import('../components/pages/warehouse/Marking.vue')
        },
        {
            path: 'documents/:id', name: "WarehousesDocumentItem",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['materials'] },
            component: () => import('../components/pages/warehouse/DocumentItem.vue')
        },
    ]
}
